export default __webpack_public_path__ + "static/media/hip.f80bb7e9.png";